
export const CONFIG = {
  appName: "Panchal Sonar Vivaah",
  contactEmail: "contact@codeimplants.com",
  contactPhone: "+91 9850929690",
  contactAddress: "Code Implants Software Technologies Pvt. Ltd., Maa Ganga Colony, Kalewadi, Pimpri-Chinchwad, Maharashtra, India 411017",
  apiEndpoint: "https://panchal-sonar-matrimony-backend.onrender.com/api/privacypolicy" ,
  processingTime: "15 business days"
};